import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary.tsx";
import { ToastProvider } from "./components/Toast.tsx";
import "./index.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/700.css";
import "./i18n/index.ts"; // initialises i18next side-effect

// Enable Fast Refresh for development
if (import.meta.hot) {
  import.meta.hot.accept();
}

// ---------------------------------------------------------------------------
// Dev-only preview pages (never included in production bundle)
// Usage: http://localhost:5173/?preview=scoring
// ---------------------------------------------------------------------------
const DEV_PREVIEW =
  import.meta.env.DEV &&
  new URLSearchParams(window.location.search).get("preview");

const ScoringPreview = DEV_PREVIEW === "scoring"
  ? lazy(() => import("./components/ScoringPreview.tsx"))
  : null;

const FeaturesPreview = DEV_PREVIEW === "features"
  ? lazy(() => import("./components/FeaturesPreview.tsx"))
  : null;

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

const PreviewComponent = ScoringPreview ?? FeaturesPreview;

if (PreviewComponent) {
  root.render(
    <Suspense fallback={<div style={{ color: "white", padding: 40, fontFamily: "Inter, sans-serif" }}>Lade Vorschau…</div>}>
      <PreviewComponent />
    </Suspense>,
  );
} else {
  root.render(
    <ErrorBoundary>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>,
  );
}
